<div class="radar-chart__wrapper">
    <h3 class="chart-header">{{name}}</h3>
    <app-chart-render [config]="config" [name]="name" [data]="data" [labels]="labels" class="charts" [scale]="scale"></app-chart-render>
</div>